"use client";
import React, { useState } from "react";

const SubmenuZone = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <li
                className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                onMouseEnter={handleToggle}
                onClick={handleToggle}
            >
                Zone ⤵
            </li>
            {isOpen && (
                <div
                    className="text-center font-medium large-submenu lg:absolute right-0 bg-white rounded-md shadow-md "
                    onMouseLeave={handleToggle}
                >
                    <ul className="py-2">
                        {[1, 2, 3, 4, 5, 6].map((i) => (
                            <li key={i}>
                                <a
                                    href={`/scoala-de-soferi-sector-${i}`}
                                    className="block px-4 py-2 text-medium text-gray-700 hover:bg-gray-100"
                                    aria-label={`Sector ${i}`}
                                    title={`Sector ${i}`}
                                >
                                    Sector {i}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </>
    );
};

export default SubmenuZone;
